var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Marijas iela 2A, Rīga, Latvia, LV-1050")])}
var staticRenderFns = []

export { render, staticRenderFns }